var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Event from './Event';

var Channel = function () {
  function Channel(name, params, dispatcher, onSuccess, onFailure) {
    _classCallCheck(this, Channel);

    this.name = name;
    this.dispatcher = dispatcher;
    this.params = params;
    this.onSuccess = onSuccess;
    this.onFailure = onFailure;
    this.callbacks = {};
    this.token = void 0;
    this.queue = [];

    var event = new Event('subscribe', {
      channel: this.name,
      params: this.params
    }, this.successLauncher, this.failureLauncher);

    this.dispatcher.triggerEvent(event);
  }

  _createClass(Channel, [{
    key: 'destroy',
    value: function destroy() {
      var event = new Event('unsubscribe', {
        channel: this.name
      });
      this.dispatcher.triggerEvent(event);

      return this.callbacks = {};
    }
  }, {
    key: 'bind',
    value: function bind(eventName, callback) {
      this.callbacks[eventName] || (this.callbacks[eventName] = []);
      return this.callbacks[eventName].push(callback);
    }
  }, {
    key: 'unbind',
    value: function unbind(eventName) {
      return delete this.callbacks[eventName];
    }
  }, {
    key: 'trigger',
    value: function trigger(eventName, message) {
      var event = new Event(eventName, {
        channel: this.name,
        data: message
      });
      if (!this.token) {
        return this.queue.push(event);
      } else {
        return this.dispatcher.triggerEvent(event);
      }
    }
  }, {
    key: 'dispatch',
    value: function dispatch(event) {
      if (this.callbacks[event.type] == null) return;

      return this.callbacks[event.type].map(function (callback) {
        return callback(event);
      });
    }
  }, {
    key: 'successLauncher',
    value: function successLauncher(data) {
      if (this.onSuccess != null) {
        return this.onSuccess(data);
      }
    }
  }, {
    key: 'failureLauncher',
    value: function failureLauncher(data) {
      if (this.onFailure != null) {
        return this.onFailure(data);
      }
    }
  }, {
    key: 'flushQueue',
    value: function flushQueue() {
      this.queue.forEach(this.dispatcher.triggerEvent);
      return this.queue = [];
    }
  }]);

  return Channel;
}();

export default Channel;